import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';

export function VectorStrokeColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemSolidBorderColor = useGetKeyFromBorderOfActiveItem('solidBorderColor');

  if (!activeItem || (activeItem && !('border' in activeItem)) || !activeItemSolidBorderColor) {
    throw new Error('border does not exist in active item');
  }

  const getColorObject = (): ColorStorage[] => {
    return getColorObjectArrayFromFillColor([activeItemSolidBorderColor]);
  };

  const updateSolidBorderColor = (solidBorderColor: RGBA, undoable = true): void => {
    activeItem.border.updateBorderColor(solidBorderColor, undoable);
  };

  const onChangeOutlineColor = (updatedColor: ColorStorage[]): void => {
    updateSolidBorderColor(updatedColor[0].color, false);
  };

  const onChangeEnded = (updatedColor: ColorStorage[]): void => {
    updateSolidBorderColor(updatedColor[0].color);
  };

  return (
    <PosterEditingBaseColorPanel
      id="vector-stroke-color-panel"
      isGradientEnabled={false}
      color={getColorObject()}
      onChangeColor={onChangeOutlineColor}
      onChangeEnded={onChangeEnded}
    />
  );
}
